import HeadLineDescription from '@/components/common/HeadLine/HeadLineDescription';

type HeadLineProps = {
  children?: React.ReactNode;
  title?: string;
  subTitle?: any;
  description?: string;
};

const HeadLine = ({ children, title, subTitle, description }: HeadLineProps) => {
  const isHideTitle = (subTitle: any) => {
    //급상승 인기 키워드, 인기 키워드, 인기 키워드(패션의류)만 title 노출
    const hideTitleCategoryName = [
      '패션잡화',
      '뷰티',
      '식품',
      '스포츠/레저/자동차',
      '출산/육아',
      '가구/인테리어',
      '생활/건강',
      '가전/디지털',
      '여행/티켓/e쿠폰',
      '해외직구',
    ] as const;
    return hideTitleCategoryName.includes(subTitle);
  };

  return (
    <div className="c-p-headline">
      {title && !isHideTitle(subTitle) && <h3 className="c-p-headline__title">{title}</h3>}
      {subTitle && subTitle !== '전체 랭킹' && <h4 className="c-p-headline__title">{subTitle}</h4>}
      {description && <HeadLineDescription description={description} />}
      {children}
    </div>
  );
};

export default HeadLine;
